import styled, { css } from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../theme/helpers/fontStyle';
import { Button } from '../button';

export const $ItemContentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  min-height: ${spacing(10)};
`;

export const $LeftSideContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing('lg')};
  flex-grow: 1;
  min-width: 0;
`;

export const $ItemTitle = styled.div<{
  $isActive: boolean;
}>`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
  display: flex;
  align-items: center;
  font-weight: ${fontWeight('semibold')};
  min-width: 0;

  && * {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors.primary : theme.systemColors.defaultTextColor};
  }
`;

export const $ItemHighlighting = styled.div`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  display: flex;
  align-items: center;
  text-align: center;
  margin: ${spacing('xs')} 0;

  && * {
    color: ${({ theme }) => theme.colors.success} !important;
  }
`;

export const $ItemHighlightingIcon = styled.span`
  margin-right: ${spacing('sm')};
  display: flex;
`;

export const $ItemDescription = styled.div`
  width: 100%;
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')}
  display: flex;
  align-items: center;

  && * {
    color: ${({ theme }) => theme.colors.paragraphTextColor} !important;
  }
  margin: ${spacing('xs')} 0;
`;

export const $ItemDistance = styled.div`
  font-weight: 700;
  ${fontStyle('sm')};
  margin: ${spacing('xs')} 0;
  && * {
    color: ${({ theme }) => theme.colors.primary} !important;
  }
`;

export const $ItemLeadingLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${spacing(14)};
  height: ${spacing(10)};
  overflow: hidden;
  text-align: center;
  ${fontStyle('sm')};

  & img,
  & svg {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const $ItemLogo = styled.div`
  width: 60px;
  display: flex;
  justify-content: center;

  & img {
    max-height: ${spacing(9)};
    max-width: 100%;
  }
`;

export const $ItemPrice = styled.div<{
  $hasPrice: boolean;
  $hasPickupPointType: boolean;
}>`
  margin-left: auto;
  white-space: nowrap;
  text-align: left;
  display: flex;
  flex-direction: column;

  @media ${media.maxWidth.sm} {
    display: flex;
    flex-direction: row;
    gap: ${spacing('sm')};
    margin-left: 0;
  }

  @media ${media.minWidth.sm} {
    text-align: ${({ $hasPickupPointType }) =>
      $hasPickupPointType ? 'left' : 'right'};
  }

  ${({ $hasPrice, theme }) =>
    $hasPrice
      ? css`
          font-weight: ${fontWeight('medium')};
          ${fontStyle('base')};
          color: ${theme.colors.primary} !important;

          & * {
            color: ${theme.colors.primary} !important;
          }

          @media ${media.maxWidth.sm} {
            margin-top: unset;
          }
        `
      : css`
          color: ${theme.colors.paragraphTextColor};
          @media ${media.maxWidth.sm} {
            color: ${theme.colors.black};
            margin-top: ${spacing('lg')};
            font-weight: ${fontWeight('medium')};
          }
        `}
`;

export const $Item = styled.button<{
  $isActive: boolean;
}>`
  background: ${({ theme }) => theme.systemColors.defaultBackground};

  width: 100%;
  min-width: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  & * {
    color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors.primary : theme.colors.paragraphTextColor};
  }

  border: 1px solid
    ${({ theme, $isActive }) =>
      $isActive ? theme.colors.primary : theme.colors.paragraphTextColor};
  border-radius: ${({ theme }) => theme.tw.radius.sm};

  text-align: left;

  padding: ${spacing('xl')};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.primary};

    & * {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  cursor: pointer;
`;

export const $ItemContentTextWrapper = styled.div`
  width: 80%;
  min-width: 0;

  @media ${media.maxWidth.sm} {
    width: 100%;
  }
`;

export const $Button = styled(Button)`
  &&,
  &&:visited,
  &&:active,
  &&:focus {
    background: transparent;
    padding: 0;
    height: auto;
    min-height: auto;
    justify-content: flex-start;
    text-align: left;
    font-weight: ${fontWeight('normal')};
    ${fontStyle('sm')};
    text-decoration-line: underline;

    &&:hover {
      background: transparent;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const $SubLineContainer = styled.div`
  border-top: 1px solid #e1e4e8;
  margin-top: ${spacing('lg')};
  padding-top: ${spacing('lg')};
`;
